export default __webpack_public_path__ + "ab2fcf799d5635373b4274fbbf26ebd5.png";